<template>
    <div class="header" @click="LanguageLayer = false">
        <div class="mask" v-if="LanguageLayer == true" @click="LanguageLayer = false"></div>
        <!-- <div class="pcShow" :style="{ 'height': offsetHeight + 'px' }"></div> -->
        <div class="pcShow" style="height: 161px"></div>
        <div class="ydShow" style="height: 67px " v-if="!APPTop"></div>
        <div class="ydShow" style="height: 164px " v-if="APPTop"></div>
        <!-- <div>userAgent:{{ userAgent }}</div> -->
        <header class="header style7 pcShow header_top" ref="elementTop" style="border-bottom: 1px solid #D9D9D9;">
            <img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon17.png" alt="img"
                class="icon17 ">
            <!--<img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon17.gif" alt="img" class="icon17 "> -->
            <div class="container ydShow_padding0">
                <!-- <div class="main-header d-flex " :class="scroll == 1 ? 'scrollTop' : scroll == 2 ? 'scrollbom' : 'headerH'"> -->
                <div class="main-header d-flex flex-column headerH">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class=" header-element pointer ydShow_padding0" @click="gohome(); switch_nav = 1;">
                            <div class="logo">
                                <svg class="icon-logo">
                                    <use xlink:href="#icon-logo"></use>
                                </svg>
                            </div>
                        </div>

                        <div class=" ydShow_padding0" v-if="country && pathName != 'index'">
                            <div class="header-control pointer">
                                <div
                                    class="block-minicart dungar-mini-cart block-header dungar-dropdown d-flex align-items-center">
                                    <!-- <img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon1.png" alt="img"
                                        class="shopcart-icon"> -->
                                    <div @click="gocontactUs()" style="margin-right: 20px;">
                                        <svg class="shopcart-icon">
                                            <use xlink:href="#icon-contactUs"></use>
                                        </svg>
                                        <span>{{ $t("message.ContactUs") }}</span>
                                    </div>

                                    <div class="language-box" v-if="hostFlag && country.localLanguage">
                                        <svg class="language-icon" @click.stop="LanguageLayer = true">
                                            <use xlink:href="#icon-icon5"></use>
                                        </svg>
                                        <div class="select-box" v-if="LanguageLayer">
                                            <div class="select-title" @click.stop="LanguageLayer = true">
                                                {{ $t("message.SelectAlanguage") }}</div>
                                            <div class="select-li"
                                                :class="localLanguage != 'en' ? 'select-checkout' : ''"
                                                @click.stop="changeLanguage(1)">{{ country.languageName }}</div>
                                            <div class="select-li"
                                                :class="localLanguage == 'en' ? 'select-checkout' : ''"
                                                @click.stop="changeLanguage(2)">English</div>
                                        </div>
                                        <div class="triangle-box" v-if="LanguageLayer"></div>
                                    </div>
                                    <svg @click="goindex()" class="shopcart-icon">
                                        <use xlink:href="#icon-icon3"></use>
                                    </svg>

                                    <div style="margin-left: -5px;" @click="goindex()">{{
                                        country.countryNameAbbreviation
                                    }}</div>
                                    <svg class="shopcart-icon" @click="goMyAccount()" v-if="!clientInfo">
                                        <use xlink:href="#icon-icon1"></use>
                                    </svg>
                                    <div class="My_d" v-else>
                                        <svg class="shopcart-icon" style="position: absolute; left: 37px;">
                                            <use xlink:href="#icon-icon1"></use>
                                        </svg>
                                        <el-select class="input_li2 input_select"
                                            style="width: 120px;height: 28px;box-sizing: border-box;" v-model="My"
                                            placeholder=' ' @change="setMy">
                                            <el-option key="1" :value="1" style=" pointer-events: none;color: #000;">
                                                Profile
                                            </el-option>
                                            <el-option key="2" :value="2">
                                                <svg class="shopcart-icon"
                                                    style="margin-left: 0;width: 113px;height: 31px;">
                                                    <use xlink:href="#icon-skidLogo"></use>
                                                </svg>
                                            </el-option>
                                            <el-option key="3" :value="3"
                                                style="font-size: 10px;text-decoration: underline">
                                                Logout
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-lg-9 country_no">{{ $t("message.BOSCHAZPortal") }}</div>
                    </div>
                    <div class="row ydShow_padding0" v-if="country && pathName != 'index'">
                        <div class="d-flex justify-content-between align-items-center">

                            <ul class="nav-d">
                                <div class="nav-item pointer" @click="gohome(); switch_nav = 1;">
                                    <div :class="nav == 1 ? 'active' : ''">{{ $t("message.Home") }}</div>

                                </div>
                                <div class="nav-item pointer" @click="goWhatsOn(); switch_nav = 1;">
                                    <div :class="nav == 2 ? 'active' : ''">{{ clientInfo && clientInfo.detailsTypeOf ==
                                        'BDC' ? $t("message.News_pdates") : $t("message.WhatSon") }}</div>

                                </div>

                                <div v-if="clientInfo && clientInfo.detailsTypeOf == 'BDC'" class="nav-item pointer"
                                    @click="goCustomerTrainingsEvents(); switch_nav = 1;">
                                    <div :class="nav == 3 ? 'active' : ''">{{ $t("message.CustomerTrainingsEvents")
                                        }}</div>
                                </div>
                                <div v-else class="nav-item pointer" @click="goAuto_tech(); switch_nav = 1;">
                                    <div :class="nav == 3 ? 'active' : ''">{{ $t("message.TechWiki") }}</div>
                                </div>

                                <div class="nav-item pointer" @click="gomanual_uploading(); switch_nav = 1;"
                                    v-if="need_dealer_import == 1">
                                    <div :class="nav == 6 ? 'active' : ''">{{ $t("message.manualUploading") }}</div>

                                </div>

                                <div v-else-if="clientInfo && clientInfo.detailsTypeOf == 'BDC'"
                                    class="nav-item pointer" @click="goBDCSpecialArea(); switch_nav = 1;">
                                    <div :class="nav == 4 ? 'active' : ''">{{ $t("message.BDCHub") }}</div>

                                </div>
                                <div class="nav-item pointer" @click="goModule(); switch_nav = 1;"
                                    v-else-if="clientInfo">
                                    <div :class="nav == 4 ? 'active' : ''">{{ $t("message.Module") }}</div>

                                </div>

                                <div class="nav-item pointer" @click="goMyAccount(); switch_nav = 1;">
                                    <div :class="nav == 5 ? 'active' : ''">{{ $t("message.MyAccount") }}</div>
                                </div>
                                <div class="nav-item pointer" @click="goWiper(); switch_nav = 1;" v-if="ModuleConcept_server_user_login.isShow == 1">
                                    <div :class="nav == 7 ? 'active' : ''"><svg class="icon-icon7">
                                                            <use xlink:href="#icon-icon7"></use>
                                                        </svg>{{ $t("message.Wiper_text1") }}</div>
                                </div>
                            </ul>
                            <div class="AutoParts">{{ $t("message.BOSCHAZPortal") }}</div>
                        </div>

                    </div>
                </div>
            </div>
        </header>
        <div class="header-device-mobile ydShow header_top" ref="elementTop2"
            :class="switch_nav == 2 ? 'switch_nav_d' : ''" :style="APPTop ? { 'top': '97px' } : ''">
            <!-- <img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon16.png" alt="img" class="icon16"> -->
            <img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon16.gif" alt="img"
                class="icon16">
            <div class="wapper">
                <div class="item mobile-logo pointer" @click="gohome(); switch_nav = 1;">
                    <div class="logo">
                        <svg class="icon-logo">
                            <use xlink:href="#icon-logo"></use>
                        </svg>
                    </div>
                </div>
                <div class="flex1"></div>
                <div class="item" v-if="country && pathName != 'index'">
                    <div class="language-box-yd" v-if="hostFlag && country.localLanguage">

                        <svg class="language-icon-yd" @click.stop="LanguageLayer = true">
                            <use xlink:href="#icon-icon5"></use>
                        </svg>

                        <div class="select-box-yd" v-if="LanguageLayer">
                            <div class="select-title-yd" @click.stop="LanguageLayer = true">Select a language</div>
                            <div class="select-li-yd" :class="localLanguage != 'en' ? 'select-checkout' : ''"
                                @click.stop="changeLanguage(1)">{{ country.languageName }}</div>
                            <div class="select-li-yd" :class="localLanguage == 'en' ? 'select-checkout' : ''"
                                @click.stop="changeLanguage(2)">English</div>
                        </div>
                        <div class="triangle-box-yd" v-if="LanguageLayer"></div>
                    </div>
                    <svg class="menu-toggle icon2" @click="goindex()">
                        <use xlink:href="#icon-icon3"></use>
                    </svg>
                    <div style="margin-left: 0px;" @click="goindex()">{{ country.countryNameAbbreviation }}</div>
                    <svg class="menu-toggle icon2" @click="goMyAccount()" v-if="!clientInfo">
                        <use xlink:href="#icon-icon1"></use>
                    </svg>
                    <div class="My_d" v-else>
                        <svg class="menu-toggle icon2" style="position: absolute; left: -6px;">
                            <use xlink:href="#icon-icon1"></use>
                        </svg>
                        <el-select class="input_li2 input_select"
                            style="width: 60px;height: 28px;box-sizing: border-box;"
                            v-model="technicalEncyclopediaLanguageTypeId" placeholder=' ' @change="setMy">

                            <el-option key="1" :value="1" style=" pointer-events: none;color: #000;">
                                Profile
                            </el-option>
                            <el-option key="2" :value="2">
                                <svg class="menu-toggle icon2" style="margin-left: 0;width: 113px;height: 31px;">
                                    <use xlink:href="#icon-skidLogo"></use>
                                </svg>
                            </el-option>
                            <el-option key="3" :value="3" style="    font-size: 11px;text-decoration: underline">
                                Logout
                            </el-option>
                        </el-select>
                    </div>

                    <svg class="menu-toggle icon2 pointer" v-if="switch_nav == 1" @click="switch_nav = 2">
                        <use xlink:href="#icon-icon2"></use>
                    </svg>
                    <svg v-if="switch_nav == 2" @click="switch_nav = 1"
                        class="menu-toggle icon2 animate__animated animate__rotateInDownLeft pointer">
                        <use xlink:href="#icon-icon4"></use>
                    </svg>

                </div>
                <div v-else class="country_no">{{ $t("message.BOSCHAZPortal") }}</div>
            </div>
            <div class="switch_nav_bg animate__animated animate__fadeIn" v-if="switch_nav == 2">
                <div class="switch_li d-flex align-items-center justify-content-between pointer"
                    @click="gohome(); switch_nav = 1;">
                    <div>{{ $t("message.Home") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div class="switch_li d-flex align-items-center justify-content-between pointer"
                    @click="goWhatsOn(); switch_nav = 1;">
                    <div>{{ clientInfo && clientInfo.detailsTypeOf == 'BDC' ? $t("message.News_pdates") :
                        $t("message.WhatSon") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>

                <div v-if="clientInfo && clientInfo.detailsTypeOf == 'BDC'"
                    class="switch_li d-flex align-items-center justify-content-between pointer"
                    @click="goCustomerTrainingsEvents(); switch_nav = 1;">
                    <div>{{ $t("message.CustomerTrainingsEvents") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div v-else class="switch_li d-flex align-items-center justify-content-between pointer"
                    @click="goAuto_tech(); switch_nav = 1;">
                    <div>{{ $t("message.TechWiki") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div class="switch_li d-flex align-items-center justify-content-between pointer"
                    v-if="need_dealer_import == 1" @click="gomanual_uploading(); switch_nav = 1;">
                    <div>{{ $t("message.manualUploading") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div class="switch_li d-flex align-items-center justify-content-between pointer"
                    v-else-if="clientInfo && clientInfo.detailsTypeOf == 'BDC'"
                    @click="goBDCSpecialArea(); switch_nav = 1;">
                    <div>{{ $t("message.BDCHub") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div class="switch_li d-flex align-items-center justify-content-between pointer" v-else-if="clientInfo"
                    @click="goModule(); switch_nav = 1;">
                    <div>{{ $t("message.Module") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>


                <div class="switch_li d-flex align-items-center justify-content-between pointer"
                    @click="goMyAccount(); switch_nav = 1;">
                    <div>{{ $t("message.MyAccount") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div class="switch_li d-flex align-items-center justify-content-between pointer" v-if="ModuleConcept_server_user_login.isShow == 1"
                    @click="goWiper(); switch_nav = 1;">
                    <div>{{ $t("message.Wiper_text1") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
                <div class="switch_li d-flex align-items-center justify-content-between pointer"
                    @click="gocontactUs(); switch_nav = 1;">
                    <div>{{ $t("message.ContactUs") }}</div>
                    <img class="menu-toggle icon21"
                        src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/icon21.png"
                        alt="img">
                </div>
            </div>


        </div>
    </div>
</template>

<script>

import SvgIcon from "@/components/svgIcon/index.vue"
import "@/components/svgIcon/svg.js" // 批量导入svg文件
import { EventBus } from "../main"
export default {
    components: {
        SvgIcon
    },
    name: 'Header',
    props: {
        msg: String
    },
    data() {
        return {
            technicalEncyclopediaLanguageTypeId: '',
            userAgent: '',
            country: '',
            nav: 1,
            switch_nav: 1,
            clientInfo: '',
            scroll: -1,
            scrollTop: '',
            offsetHeight: '',
            pathName: '',
            localLanguage: '',
            LanguageLayer: false,
            hostFlag: false,
            need_dealer_import: '',
            APPTop: false,
            My: '',
            VUE_APP: '',
            ModuleConcept_server_user_login:'',
        }
    },
    watch: {
        $route(to, from, next) {
            var that = this
            that.scroll = -1
            const currentRoute = that.$router.currentRoute;
            that.pathName = currentRoute.name
            if (localStorage.getItem("client_info")) {
                this.clientInfo = JSON.parse(localStorage.getItem("client_info"))
                // console.log('clientInfo==', this.clientInfo)
            } else {
                this.clientInfo = ''
            }
            this.VUE_APP = JSON.parse(localStorage.getItem("VUE_APP"))
            setTimeout(function () {
                // that.offsetHeight = that.$refs.elementTop.offsetHeight || that.$refs.elementTop2.offsetHeight
                // console.log('offsetHeight____________', that.offsetHeight)
                // that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            }, 800)
        },
    },
    created() {
        var that = this
        this.VUE_APP = JSON.parse(localStorage.getItem("VUE_APP"))
        if (localStorage.getItem("client_info")) {
            this.clientInfo = JSON.parse(localStorage.getItem("client_info"))
            console.log('this.client_info.clientType_________', this.clientInfo.clientType)
            console.log('this.client_info.detailsTypeOf_________', this.clientInfo.detailsTypeOf)
            // console.log('clientInfo==', this.clientInfo)
        } else {
            this.clientInfo = ''
        }
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // if (true) {
        //     // 页面在内嵌APP中
        //     if (/iPhone/.test(userAgent) && !window.MSStream) {
        //         // 页面在内嵌ios中
        //         this.APPTop = true
        //         localStorage.setItem("APPTop", true)
        //         this.userAgent = userAgent
        //         console.log('userAgent==',userAgent)
        //         alert('页面在APP内嵌ios中',userAgent)
        //     }


        // } else {
        //     this.APPTop = false
        //     // 页面在浏览器中
        // }
        if (localStorage.getItem("ModuleConcept_server_user_login")) {
            this.ModuleConcept_server_user_login = JSON.parse(localStorage.getItem("ModuleConcept_server_user_login"))
        }
        EventBus.$on('ModuleConcept_server_user_login', (newValue) => {
            console.log('ModuleConcept_server_user_login=====', newValue);
            that.ModuleConcept_server_user_login = newValue
            localStorage.setItem("ModuleConcept_server_user_login", JSON.stringify(newValue))
        })
        EventBus.$on('nav', (newValue) => {
            // 处理全局变量变化
            // console.log('nav=====', newValue);
            if (localStorage.getItem("client_info")) {
                this.clientInfo = JSON.parse(localStorage.getItem("client_info"))
                // console.log('clientInfo==', this.clientInfo)
            } else {
                this.clientInfo = ''
            }
            that.country = JSON.parse(localStorage.getItem("country")) || ''
            // console.log('that.country ====================', that.country)
            that.nav = newValue.nav
            localStorage.setItem("nav", that.nav)
            that.localLanguage = localStorage.getItem('localLanguage') || 'en'
            setTimeout(function () {
                that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
            }, 200)
            that.need_dealer_import = localStorage.getItem("need_dealer_import") || 0
            console.log('need_dealer_import==============', that.need_dealer_import)

        })
        EventBus.$on('scrollTop', (newValue) => {
            that.scrollTop = newValue.scrollTop
            if (that.scrollTop >= 20) {
                if (that.scroll == 2 || that.scroll == -1) {
                    that.offsetHeight = 103
                    that.scroll = 1
                }

            } else {
                if (that.scroll == 1 || that.scroll == -1) {
                    that.offsetHeight = 163
                    that.scroll = 2
                }
            }
            // that.offsetHeight = that.$refs.elementTop.offsetHeight
        })

        this.localLanguage = localStorage.getItem('localLanguage') || 'en'
        this.hostFlag = localStorage.getItem('host') === 'http://ap-portal.boschaftermarket.com/bosch-enh5-api/api' ? false : true
    },
    mounted() {
        var that = this
        that.country = JSON.parse(localStorage.getItem("country")) || ''
        // console.log('elementTop==', this.$refs.elementTop.offsetHeight)
        this.offsetHeight = this.$refs.elementTop.offsetHeight
        this.need_dealer_import = localStorage.getItem("need_dealer_import") || 0
        const currentRoute = this.$router.currentRoute;
        this.pathName = currentRoute.name
        // console.log('this.pathName===', this.pathName)
    },
    beforeDestroy() {
        EventBus.$off('nav')
    },
    methods: {
        setMy(e) {
            console.log(e)
            if (e == 1) {
                this.goMyAccount()
            } else if (e == 2) {
                let locationUrl = window.location.host
                if (locationUrl == 'ap-portal.boschaftermarket.com') {
                    console.log('正式环境')
                    window.location.href = 'https://singlekey-id.com/myprofile/'
                } else {
                    window.location.href = 'https://stage.singlekey-id.com/myprofile/'
                }
                // this.ssoLogin()
            } else {
                this.clare2()
            }
            this.My = ''
        },
        // 退出
        clare2() {
            let url
            var that = this
            if (this.VUE_APP.env == 'dev') {
                url = 'https://q.ap-portal.boschaftermarket.com/MY/login_index'
            } else {
                url = location.href
            }


            that.$flyNo.request({
                method: 'GET',
                url: that.httpUrl.auth_logout,
                body: {
                }
            }).then(res => {
                if (!res) return false
                console.log('--------------——', that.httpUrl.auth_logout, '_res==', res)


            })

            if (!localStorage.getItem('ciam_login')) {
                localStorage.removeItem("ciam_login")
                this.$router.replace({
                    name: "login_index",
                });
                return false
            }
            var index = url.lastIndexOf('/')
            let redirect_uri = url.substring(0, index) + '/login_index'
            console.log('redirect_uri===', redirect_uri)
            let targetUrl = this.VUE_APP.VUE_APP_CIAM_URL + '/endsession'
            let paramStr = '?'
            const params = {
                id_token_hint: JSON.parse(localStorage.getItem('ciam_login')).userSsoToken,
                post_logout_redirect_uri: redirect_uri + '?status=endsession'
            }
            let flag = false
            for (const p in params) {
                if (p && params[p] !== '') {
                    if (!flag) {
                        paramStr = paramStr + p + '=' + params[p]
                        flag = true
                    } else {
                        if (p && params[p] !== '') {
                            paramStr = paramStr + '&' + p + '=' + params[p]
                        }
                    }
                }
            }
            window.location.href = targetUrl + paramStr

        },
        // 点击登录
        ssoLogin() {
            var that = this
            // let redirect_uri = 'https://q.ap-portal.boschaftermarket.com/MY/login_index'
            let redirect_uri = location.href
            console.log('redirect_uri===', redirect_uri)
            // https://stage.singlekey-id.com/auth/connect/authorize?scope=openid+profile+phone+email&response_type=code&client_id=E0E564FB-FDA2-4EA2-8DAF-7F688B35C873&redirect_uri=https%3A%2F%2Fq.ap-portal.boschaftermarket.com%2FTH%2Flogin_index
            let targetUrl = this.VUE_APP.VUE_APP_CIAM_URL + '/authorize'

            let paramStr = '?'
            const params = {
                response_type: 'code',
                scope: 'openid+profile+offline_access+phone+email',
                client_id: this.VUE_APP.VUE_APP_CIAM_CLIENT_ID,
                redirect_uri: redirect_uri,
                style_id: 'aa_bsch_wsp_au',
                input: 'phone'

            }
            var ciam_login = {
                redirect_uri: redirect_uri
            }
            localStorage.setItem("ciam_login", JSON.stringify(ciam_login))
            let flag = false
            for (const p in params) {
                if (p && params[p] !== '') {
                    if (!flag) {
                        paramStr = paramStr + p + '=' + params[p]
                        flag = true
                    } else {
                        if (p && params[p] !== '') {
                            paramStr = paramStr + '&' + p + '=' + params[p]
                        }
                    }
                }
            }
            console.log(targetUrl + paramStr)
            var urlNew = targetUrl + paramStr

            // that.$layer.alert('您即将跳转到' + urlNew, {
            //     closeBtn: 1,
            //     area: ["370px", "auto"],
            //     title: '',
            //     showCancelButton: false,
            //     btn: [that.$t("message.OK")],

            // }, function () {
            //     that.$layer.closeAll();
            window.location.href = urlNew
            localStorage.removeItem("need_dealer_import")
            // });

        },
        changeLanguage(num) {
            this.LanguageLayer = false
            const country = JSON.parse(localStorage.getItem("country")) || ''
            if (!country) return
            if (num == 1) {
                this.localLanguage = country.localLanguage
            } else {
                this.localLanguage = 'en'
            }

            if (this.localLanguage == 'en') {
                this.$i18n.locale = 'en';
                localStorage.setItem('localLanguage', 'en')
            } else {
                this.$i18n.locale = country.localLanguage;
                localStorage.setItem('localLanguage', country.localLanguage)
            }

            if (EventBus) { //埋点
                var obj = {}
                obj.name = 'wsp_language_click'
                obj.params = {
                    Typy: 'Users routine operations',
                    Name: 'Language switch',
                    language_name: this.localLanguage,
                }
                EventBus.$emit('google-analytics', obj);
            }
            EventBus.$emit('localLanguage', localStorage.getItem('localLanguage'));
        },
        goindex() {
            if (!localStorage.getItem("country")) return

            this.switch_nav = 1
            this.$router.push({
                name: "index"
            }, () => {
                this.$nextTick(() => {
                    this.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        setNav() {
            var that = this
            this.country = localStorage.getItem("country") || ''
            if (localStorage.getItem("client_info")) {
                this.clientInfo = JSON.parse(localStorage.getItem("client_info"))
                // console.log('clientInfo==', this.clientInfo)
            }
            const currentRoute = this.$router.currentRoute;
            let path = currentRoute.path
            this.pathName = currentRoute.name
            // console.log('path========', currentRoute.path);
            if (path == '/Home') {
                this.nav = 1
            } else if (path == '/WhatsOn') {
                this.nav = 2
            } else if (path == '/Rewards') {
                this.nav = 3
            } else if (path == '/Module') {
                this.nav = 4
            } else if (path == '/MyAccount') {
                this.nav = 5
            } else if (path == '/ModuleConcept') {
                this.nav = 7
            }
        },
        gopersonalData_index() {
            var that = this
            this.switch_nav = 1
            if (localStorage.getItem("client_info")) {
                that.$router.push({
                    name: "personalData_index"
                }, () => {
                    that.$nextTick(() => {
                        that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                    })
                })
            } else {
                that.$router.push({
                    name: "login_index",
                }, () => {
                    that.$nextTick(() => {
                        that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                    })
                });
            }
        },
        gohome() {
            var that = this
            this.nav = 1
            var countryNameAbbreviation = JSON.parse(localStorage.getItem("country")).countryNameAbbreviation
            this.$router.push({ name: 'Home', params: { myParam: countryNameAbbreviation } }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            });
        },
        goWhatsOn() {

            var that = this
            this.nav = 2
            that.$router.push({
                name: "WhatsOn"
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },

        goRewards() {
            var that = this
            this.nav = 3
            that.$router.push({
                name: "Rewards"
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        gocontactUs() {
            var that = this
            that.$router.push({
                name: "contactUs"
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        goAuto_tech() {
            var that = this
            this.nav = 3
            that.$router.push({
                name: "Auto_tech"
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        goCustomerTrainingsEvents() {
            var that = this
            this.nav = 3
            that.$router.push({
                name: "CustomerTrainingsEvents"
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        goWiper() {
            var that = this
            this.nav = 7
            that.$router.push({
                name: "ModuleConcept"
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        goBDCSpecialArea() {
            var that = this
            this.nav = 4
            that.$router.push({
                name: "BDCSpecialArea",
            }, () => {
                that.$nextTick(() => {
                    that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                })
            })
        },
        goModule() {
            var that = this
            this.nav = 4

            if (!localStorage.getItem("client_info")) {
                that.$router.push({
                    name: "Module"
                }, () => {
                    // that.$nextTick(() => {
                    //     that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                    // })
                })
                return false
            }
            that.$flyNo.request({
                method: 'GET',
                url: that.httpUrl.signed_verifySigned,
                body: {
                }
            }).then(res => {
                if (!res) return false
                console.log('--------------——', that.httpUrl.signed_verifySigned, '_res==', res)
                // 0未申请，1审核中，2审核通过
                localStorage.setItem("signed_verifySigned_contractStatus", res.resultData.contractStatus)

                // 0未申请，1审核中，2审核通过
                if (localStorage.getItem("signed_verifySigned_contractStatus") == 0 || !localStorage.getItem("clientToken")) {
                    that.$router.push({
                        name: "Module"
                    }, () => {
                        that.$nextTick(() => {
                            that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                        })
                    })
                    return false
                } else if (localStorage.getItem("signed_verifySigned_contractStatus") == 1) {
                    that.$router.push({
                        name: "BSSList"
                    }, () => {
                        that.$nextTick(() => {
                            that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                        })
                    })
                } else if (localStorage.getItem("signed_verifySigned_contractStatus") == 2) {
                    that.$router.push({
                        name: "BSSList"
                    }, () => {
                        that.$nextTick(() => {
                            that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                        })
                    })
                } else {
                    that.$router.push({
                        name: "Module"
                    }, () => {
                        // that.$nextTick(() => {
                        //     that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                        // })
                    })
                }


            })
        },
        gomanual_uploading() {
            var that = this
            this.nav = 6
            that.$router.push({
                name: "manual_uploading"
            }, () => {
                // that.$nextTick(() => {
                //     that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                // })
            })
        },
        goMyAccount() {
            // console.log('2222')
            var that = this
            if (localStorage.getItem("client_info")) {
                that.nav = 5
                that.$router.push({
                    name: "MyAccount",
                }, () => {
                    that.$nextTick(() => {
                        that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                    })
                })
            } else {
                that.$router.push({
                    name: "login_index",
                }, () => {
                    that.$nextTick(() => {
                        that.$refs.elementTop.scrollIntoView({ behavior: 'smooth' });
                    })
                });
            }

        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.icon-icon7 {
    width: 26px;
    height: 26px;
    margin-right: 10px;
}
.icon-icon7 use {
    fill: #007BBF;
}
.My_d {
    position: relative;
    height: 28px;
    display: flex;
    align-items: center;

    .el-select-dropdown__item,
    el-option {
        text-align: center;
    }

    .el-select-dropdown {
        left: 255px;
    }

}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.select-title-yd {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 18px;
    font-size: 14px;
    color: #000;
}

.select-li-yd {
    width: 100%;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #4A4A4A;
}

.select-checkout-yd {
    color: #000;
}

.select-li-yd:hover {
    color: #007BBF;
}

.triangle-box-yd {
    position: absolute;
    top: 23px;
    left: 7px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid #fff;
}

.select-box-yd {
    position: absolute;
    padding: 10px;
    top: 38px;
    left: -125px;
    width: 161px;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
}

.language-box-yd {
    position: relative;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: start;
}

.language-icon-yd {
    width: 24px;
    height: 24px;
}




.select-title {
    width: 100%;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: bold;
}

.select-li {
    width: 100%;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #4A4A4A;
}

.select-checkout {
    color: #007BC0;
    background-color: #F4F9FF;
}

.select-li:hover {
    color: #007BBF;
}

.triangle-box {
    position: absolute;
    top: 48px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 14px solid #fff;
}

.select-box {
    position: absolute;
    padding: 10px;
    top: 61px;
    left: -150px;
    width: 190px;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
}

.language-box {
    position: relative;
    width: 58px;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.language-icon {
    width: 43px;
    height: 43px;
}

.header-control {
    position: relative;
    left: 6px;
}

.pcShow .nav-d {
    padding-top: 10px;
    margin-left: -20px;
}

.AutoParts {
    font-weight: bolder;
    align-self: flex-end;
    padding-bottom: 10px;
    color: #000;
}

.nav-item {
    flex: initial;

}

.nav-item div {
    padding: 10px 20px;
}

.nav-item:hover {
    color: #007BBF;

}

.headerH {
    padding-top: 20px;
    // padding: 20px 0;
}

.scrollTop {
    animation-name: paddingChange;
    animation-duration: 0.5s;
    /* 动画持续时间 */
    animation-fill-mode: forwards;
    /* 动画结束后保持最后一帧的样式 */
    animation-timing-function: ease-out;
    padding: 50px 0;
}

@keyframes paddingChange {
    from {
        padding: 50px 0;
    }

    to {
        padding: 20px 0;
    }
}

.scrollbom {
    animation-name: paddingChange2;
    animation-duration: 0.1s;
    /* 动画持续时间 */
    animation-fill-mode: forwards;
    /* 动画结束后保持最后一帧的样式 */
    animation-timing-function: ease;
    padding: 20px 0;
}

@keyframes paddingChange2 {
    from {
        padding: 20px 0;
    }

    to {
        padding: 50px 0;
    }
}

.header_top {
    position: fixed;
    // position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
}

.icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: -0.15em;
}

.svg-icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: -0.15em;
}

.mobile-logo {
    width: 118px;
    height: auto;
}

.country_no {
    color: #000;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: bold;
}

.header {
    background: #fff;
}

.switch_nav_d {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    z-index: 9999;
    pointer-events: auto;
}

.switch_nav_bg {
    padding-top: 10px;
    width: 100%;
    flex: 1;
    background: #fff;

}

.switch_li {
    height: 66px;
    padding: 0 18px;
    box-sizing: border-box;
    border-bottom: 1px solid #F2F2F2;

}

.icon21 {
    width: 7px;
    height: auto;
}
</style>
